import {
  ActivatedRouteSnapshot,
  BaseRouteReuseStrategy,
  RouteReuseStrategy
} from '@angular/router';

import { reloadQueryParamKey } from './routing.constants';

class CustomRouteReuseStrategy extends BaseRouteReuseStrategy {
  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    const isReloading = future.queryParamMap.has(reloadQueryParamKey);

    const areSameParams =
      JSON.stringify(future.params) && JSON.stringify(curr.params);
    const isSameRoute =
      future.routeConfig === curr.routeConfig && areSameParams;

    if (isSameRoute && !isReloading) {
      return true;
    }

    return false;
  }
}

export const CUSTOM_ROUTE_REUSE_STRATEGY_PROVIDER = {
  provide: RouteReuseStrategy,
  useClass: CustomRouteReuseStrategy
};
